/**
 * _authed pathless layout route — protects all nested routes behind authentication.
 *
 * C02 will enhance this with real Firebase auth checks. For now it uses
 * the RouterContext user (populated in main.tsx from useUser()).
 */
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import type { RouterContext } from "@/router";

function AuthedLayout() {
  return <Outlet />;
}

export const Route = createFileRoute("/_authed")({
  beforeLoad: ({ context }) => {
    const { user } = context as RouterContext;
    if (!user) {
      throw redirect({ to: "/sign-in" });
    }
  },
  component: AuthedLayout,
});
